import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbLoginComponent } from '@nebular/auth';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private readonly keycloak: KeycloakService, private router: Router) {}

  ngOnInit(): void {

    if (this.keycloak.isLoggedIn()) {
        // User is logged in, perform necessary actions
        console.log('Login: User is logged in,  rediection to /masarat/home');
        this.router.navigate(['/masarat/home']); 

    } else {
        // User is not logged in or login failed
        console.log('Login : User is not logged in');
        this.keycloak.login();
    }
     
  }


}
